/* eslint-disable @typescript-eslint/no-explicit-any */
import { CardLayeredVariations } from '@marriott/mi-ui-library';
import { generateRandomNumber } from '@marriott/shared/mi-helper-utils';
import { getCtaUrl } from '../../../utils/CommonUtils';

export const getTrackingProperties = (model: any) => {
  return {
    trackingContentPosition: 'trackingContentPosition',
    trackingOfferType: 'trackingOfferType',
    atCCeVar48: 'atCCeVar48',
    trackingDescription: model?.trackingProperties?.trackingDescription,
    trackingTag: 'trackingTag',
    isCoBrand: false,
    clickTrack: model?.trackingProperties?.clickTrack,
    impressionTrack: true,
    impressionCount: true,
    impressionEventType: 'impressionEventType',
    merchandisingCategory: 'merchandisingCategory',
    additionalTrackingVariables: 'additionalTrackingVariables',
    location: model?.trackingProperties?.location,
    payloadType: 'payloadType',
    compName: 'compName',
    enableScrollingBehavior: model?.trackingProperties?.enableScrollingBehavior,
    cardLocation: model?.id ?? model?.trackingProperties?.cardLocation,
    leftArrowDesc: model?.trackingProperties?.leftArrowDesc,
    rightArrowDesc: model?.trackingProperties?.rightArrowDesc,
    description: model?.ctaLabel ?? model?.trackingProperties?.description,
  };
};

export function shuffleResorts<T>(defaultResorts: T[]): T[] {
  const shuffledResort = defaultResorts ? [...defaultResorts] : [];
  for (let i = shuffledResort.length - 1; i > 0; i--) {
    const j = Math.floor(generateRandomNumber() * (i + 1));
    [shuffledResort[i], shuffledResort[j]] = [shuffledResort[j], shuffledResort[i]];
  }
  return shuffledResort;
}

export function generateOffsetNumber(model: any, resortKeys: any): number {
  const cardLimit = parseInt(model?.maxResortsCount);
  let newOffsetCount = 0;
  if (typeof window !== 'undefined' && localStorage.getItem('resortObject') != null) {
    const resortObject: any = localStorage.getItem('resortObject');
    const parsedResortObject = JSON.parse(resortObject);
    const availableResortForKey = parsedResortObject[resortKeys];
    const maxLimitOffset = availableResortForKey - cardLimit;
    if (availableResortForKey && availableResortForKey !== undefined && availableResortForKey > cardLimit) {
      newOffsetCount = Math.floor(generateRandomNumber() * (maxLimitOffset - 1 + 1)) + 1;
    }
  }
  return newOffsetCount;
}

export const getImageByVariation = (variation?: CardLayeredVariations, images?: any) => {
  switch (variation) {
    case CardLayeredVariations.Square:
      return images?.square;
    case CardLayeredVariations.Wide:
      return images?.wideHorizontal;
    default:
      return images?.classicVertical;
  }
};

export const getDisplayImage = (mediaNode: any, variation?: CardLayeredVariations, brandPhotos?: any[]) => {
  const primaryImage = getImageByVariation(
    variation,
    mediaNode?.imagesByTags?.assets?.[0]?.imageUrls || mediaNode?.primaryImage?.edges?.[0]?.node?.imageUrls
  );
  const fallbackImage = brandPhotos?.[0]?.content?.[0]?.url;
  return primaryImage || fallbackImage;
};

export const mapResortItem = (item: any, cardLayeredVariation: any, subDirectoryContextPath: any) => {
  const node = item?.node;
  const basicInfo = node?.basicInformation;
  const mediaNode = node?.media;
  const brandPhotos = basicInfo?.brand?.photos ?? [];

  return {
    image: getDisplayImage(mediaNode, cardLayeredVariation, brandPhotos),
    altText:
      mediaNode?.imagesByTags?.assets?.[0]?.alternateDescription ||
      mediaNode?.primaryImage?.edges?.[0]?.node?.alternateDescription,
    header: basicInfo?.name,
    propertyName: basicInfo?.name,
    ctaUrl: getCtaUrl(node, subDirectoryContextPath),
    newProperty: basicInfo?.newProperty,
    isFullyRenovated: basicInfo?.isFullyRenovated,
    isRecentlyRenovated: basicInfo?.isRecentlyRenovated,
    isAdultsOnly: basicInfo?.isAdultsOnly,
    hasRenovatedRooms: basicInfo?.hasRenovatedRooms,
    country: node?.contactInformation?.address?.country?.description,
    brandDetails: basicInfo?.brand,
  };
};
